// extracted by mini-css-extract-plugin
module.exports = {"rating":"bx-z","numberOfStars":"cx-z","count":"dx-z"};